module.exports = __webpack_public_path__ + "static/img/che2.13ea822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che2.png
// module id = 9Qey
// module chunks = 0